<template>
    <svg width="393" height="53" viewBox="0 0 393 53" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M275.9 0H231V52.9H275.9C284 52.9 290.6 46.4 290.6 38.3V14.7C290.6 6.6 284 0 275.9 0ZM272.3 41.5H244.8V11.5H272.3C274.7 
                11.5 276.6 13.4 276.6 15.8V37.1C276.6 39.6 274.7 41.5 272.3 41.5C272.2 41.5 272.2 41.5 272.3 41.5Z"
            fill="white"
        />
        <path
            d="M315.4 0H301.1V53H315.4V0Z"
            fill="white"
        />
        <path
            d="M16.1 0H0L8 13.9L16.1 0Z"
            fill="white"
        />
        <path
            d="M56.9996 0L36.5996 35.3L19.6996 6.2L11.5996 20L27.7996 47.9C29.4996 51 32.8996 53 36.4996 53C40.0996 53 43.4996 51.1 45.2996 47.9L73.0996 0H56.9996Z"
            fill="white"
        />
        <path
            d="M165 38.3C165 46.4 171.6 53 179.8 53H220.3V41.5H183V41.4C180.8 41.2 179.1 39.3 179.1 37.1V32.2H220.3V20.8H179.1V15.9C179.1 13.5 181 11.6 183.4 
                11.6H220.3V0H179.9C171.8 0 165.2 6.5 165.1 14.6L165 38.3Z"
            fill="white"
        />
        <path
            d="M140.4 52.9H154.4V10C154.4 4.5 149.9 0 144.3 0H144.2C140.6 0 137.2 1.9 135.4 5L116 38.5L96.4 5C94.6 1.9 91.2 0 87.6 0H87.5C82 0 77.5 4.5 77.5 
                10V53H91.5V21.1L107.2 48C109 51.1 112.4 53 116 53C119.6 53 123 51.1 124.8 48L140.5 21.1L140.4 52.9Z"
            fill="white"
        />
        <path
            d="M365.1 5C363.3 1.9 359.9 0 356.3 0C352.7 0 349.3 1.9 347.5 5L319.6 53H334.6L341.2 41.5H371.1L378 53H393L365.1 5ZM356.4 15.7L366 32.2H346.9"
            fill="white"
        />
    </svg>
</template>
